import { CommonModule } from '@angular/common';
import { ViewEncapsulation, ChangeDetectionStrategy, Input, Component } from '@angular/core';
import { Filter } from '../filters';
import { FilterRenderer } from './filter-renderer';

@Component({
  selector: 'cbre-default-filter-label-renderer',
  template: ` <div class="fx--h fx--ali-center">
    <label class="form-field__label" [attr.for]="filter.key">{{ filter.value }}</label>
  </div>`,
  imports: [CommonModule],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultFilterLabelRendererComponent implements FilterRenderer<Filter> {
  @Input() filter: Filter;
}
